import React, { useEffect, useState, useRef, useMemo  } from "react";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { checkPermissions } from "components/Common/ChkPermissions";
import PopupWindow from "components/Common/PopupWindow";
import Loader from "components/Common/Loader";
import CantAccessPage from "components/Common/CantAccessPage";
import { FaCopy, FaRegClipboard } from "react-icons/fa";
import { getWorkOrderDetailsAPIURL } from "BaseComponentAPI/WorkOrderListAPI";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
//import TableContainer from 'components/Common/TableContainer';
//import {  Input, Button, Label, Row, Col, Form, FormGroup } from 'reactstrap';


const WorkOrderDetails = () => {
    const authUser = useSelector((state) => state.Login);
    document.title = "Cockpit";

    const { woId, woExId } = useParams();

    const navigate = useNavigate();

    const location = useLocation();
    const { fromDate, toDate } = location.state || {};

    // console.log("Received From:", fromDate, "To:", toDate);

    const storedPermissions = JSON.parse(localStorage.getItem("permissions")) || {};
    const { canRead } = checkPermissions(storedPermissions);

    const [loaderOption, setLoaderOption] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("");

    const [postponeDate, setPostponeDate] = useState("");
    const [reason, setReason] = useState("");
    const [remark, setRemark] = useState("");

    const [workOrderInfo, setWorkOrderInfo] = useState(
        [
            { label: "WO Serial : ", key: "woSerialNo" },
            { label: "WO Type : ", key: "woType", bold: true },
            { label: "WO Final Amount ₹ : ", key: "woFinalAmount", bold: true },
            { label: "First Exe. Date : ", key: "firstExecutionDate", bold: true },
            { label: "First Exe.Time : ", key: "firstExecutionTime", bold: true },
            { label: "Total Exe. Pending : ", key: "noOfExecutionPending", color: "red", bold: true },
            { label: "Total Product Exe. : ", key: "totalProductExecutions" },
            { label: "Total Exe. Created : ", key: "noOfExecutionCreatedAtSystem" },
            { label: "Total Exe. Completed : ", key: "noOfExecutionCompleted" },
            { label: "WO Booked At : ", key: "woBookedAt" },
            { label: "WO Booked By : ", key: "woBookedBy" },
            { label: "", key: "" },
            { label: "Payment Mode : ", key: "woPaymentMode" },
            { label: "Payment Status : ", key: "woPaymentStatus" },
            {
                label: "Message For Schedular : ",
                key: "messageForScheduler",
                color: "red",
                bold: true,
                fullWidth: true,
            },
            { label: "Is WO Cancelled : ", key: "isWoCancelled", bold: true },
            { label: "Cancellation At : ", key: "woCancellationDateTime" },
            { label: "Cancellation Reason : ", key: "woCancellationReason" },
            { label: "Cancellation Remark : ", key: "woCancellationRemark" },
            { label: "Cancellation By : ", key: "woCancellationBy" },
            { label: "Reserved Field : ", key: "reserverField" },
        ]
    );

    const [customerDetails, setCustomerDetails] = useState(
        [
            { label: "Customer Name : ", key: "customerName", bold: true },
            { label: "Mobile No : ", key: "customersPrimaryMobileNo" },
            { label: "Complaint Raised : ", key: "isWoComplaintRaised" },
            { label: "Billing Name : ", key: "billingName", bold: true },
            { label: "Alternate Mobile No : ", key: "customersSecondryMobileNo" },
            { label: "Complaint Count : ", key: "woComplaintCount" },
            {
                label: "Detail Address : ",
                key: "woDetailAddress",
                half: true,
                copy: true
            },
            {
                label: "Service Location : ",
                key: "woServiceLocation",
                half: true,
                copy: true
            },
        ]
    );

    const [productDetails, setProductDetails] = useState([
        { label: "Product Name : ", key: "productName", bold: true },
        { label: "Negoitiated Price ₹ : ", key: "negotiatedPrice", bold: true },
        { label: "Sr. No. : ", key: "srNo" },
        { label: "Product Sub Category : ", key: "productSubCategoryName" },
        { label: "MRP ₹ : ", key: "mrp" },
        { label: "Quantity : ", key: "qty" },
        { label: "Product Category : ", key: "productCategoryName" },
        { label: "Guarantee : : ", key: "guarantee" },
        { label: "Validity : ", key: "validity" },
        { label: "Executions : ", key: "productExecutions" },
        { label: "Sys. Executions : ", key: "" },
        { label: "Execution Interval : ", key: "executionInterval" },
        { label: "Execution Completed : ", key: "noOfExeCompleted" },
        { label: "Execution Pending : ", key: "noOfExePending", color: "red", bold: true },
        { label: "Is Gurantee Over : ", key: "isGuaranteeOver" },
        { label: "Gurantee Finish Date : ", key: "guaranteeFinishDate" },

    ])




    const [executionDetails, setExecutionDetails] = useState([
        { label: "Exe Serial : ", key: "exeSerialNo", bold: true },
        { label: "WO Serial : ", key: "woSerialNo" },
        { label: "Sr. No. : ", key: "srNo", bold: true },
        { label: "Exe. Date : ", key: "executionDate" },
        { label: "WO Type : ", key: "woType" },
        { label: "Execution No : : ", key: "executionNo" },
        { label: "Exe. Time : ", key: "executionTime", bold: true },
        { label: "Product Name : ", key: "exeProduct", bold: true },
        { label: "Payment Mode : ", key: "paymentMode" },
        { label: "Time Require : ", key: "executionTimeRequire" },
        { label: "Product Sub Category : ", key: "exeProductSubCategory" },
        { label: "Received Amount ₹ : ", key: "exeAmountReceived" },
        { label: "Execution Amount ₹ : ", key: "exeAmount" },
        { label: "Product Category : ", key: "exeProductCategory", color: "red", bold: true },
        { label: "Execution Status : ", key: "executionStatus" },
        { label: "Field Executive : ", key: "fieldExecutiveName" },
        { label: "Exe. Completed  : ", key: "isExecutionCompleted" },
        
        { label: "Exe. Completed At : ", key: "exeCompletedDatetime" },
        { label: "Telecaller Name : ", key: "telecallerName" },
        { label: "Scheduler Name : ", key: "schedulerName" },
        { label: "Cancellation At : ", key: "exeCancellationDatetime" },
        {
            label: "Message For Schedular : ",
            key: "messageForScheduler",
            color: "red",
            bold: true,
            fullWidth: true,
        },
        { label: "Cancellation By : ", key: "exeCancellationBy" },
        { label: "Exe. Cancelled : ", key: "isExecutionCancelled" },

    ])

    // console.log(JSON.stringify(productDetails))


    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => setIsPopupVisible(false);

    const isValidValue = (val) =>
        val !== undefined &&
        val !== null &&
        val.toString().trim() !== "";

    const getExecutionStatus = (execution) => {

        console.log('execution?.isExecutionCancelled- ' + isValidValue(execution?.isExecutionCancelled));

        if (isValidValue(execution?.isExecutionCancelled) && execution?.isExecutionCancelled === "Yes") {
            const isCancelled = execution.isExecutionCancelled;
            console.log('in isExecutionCancelled ' + isCancelled);
             if (isCancelled === "Yes") return "cancelled";
        }

        if (isValidValue(execution?.isExecutionCompleted) && execution?.isExecutionCompleted ==="Yes" ) {
            const isCompleted = execution.isExecutionCompleted;
            console.log('in isExecutionCompleted ' + isCompleted);
            if (isCompleted === "Yes") return "completed";           
        }

        if (isValidValue(execution?.executionDate) && isValidValue(execution?.executionTime)) {
            
            const now = new Date();
            const date = execution.executionDate;
            const time = execution.executionTime;
            console.log('in executionDate ' + date + ' - ' + time);

            const [day, month, year] = date.split("/");
            const scheduled = new Date(`${year}-${month}-${day} ${time}`);
            console.log('scheduled - ' + scheduled + ' - '  + now);
            if (scheduled < now) return "delayed";
        }

       
        // const isCompleted = execution.isExecutionCompleted;
        // const isCancelled = execution.isExecutionCancelled;
        // const date = execution.executionDate;
        // const time = execution.executionTime;
        // console.log('date - ' + execution.executionDate + ' - '  + time);
        // if (isCancelled === "Yes") return "cancelled";
        // if (isCompleted === "Yes") return "completed";

        
        // if (date && time) {
        //     const [day, month, year] = date.split("/");
        //     const scheduled = new Date(`${year}-${month}-${day} ${time}`);
        //     console.log('scheduled - ' + scheduled + ' - '  + now);
        //     if (scheduled < now) return "delayed";
        // }

        return "pending";
    };



const getBadgeClass = (status) => {
  switch (status) {
    case "completed":
      return "bg-success";
    case "cancelled":
      return "bg-danger";
    case "delayed":
      return "bg-dark";
    default:
      return "bg-warning";
  }
};

const getStatusLabel = (status) => {
  if (status === "completed") return "Completed";
  if (status === "cancelled") return "Cancelled";
  if (status === "delayed") return "Delayed";
  return "Pending";
};

const processedExecutions = useMemo(() => {
   // console.log('This is processedExecutions');
  return executionDetails.map((execution) => ({
    execution,
    //status: getExecutionStatus(execution),
    status: "",
    
  }));
}, [executionDetails]);


const hasFetched = useRef(false);
    // useEffect(() => {
    //         if (hasFetched.current) return;

    //     hasFetched.current = true;
    //     getData();
    // }, [authUser])

   useEffect(() => {
        if (hasFetched.current) return;

        if (!authUser?.headers?.userUUID) return;

        hasFetched.current = true;
        getData();
}, [authUser?.headers?.userUUID]);

    // ✅ Helper Functions (Schedular, WorkOrder, PaymentMode)
    const getData = async () => {
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            try {
                console.log(`${getWorkOrderDetailsAPIURL}?userUUID=${authUser.headers.userUUID}&exeUUID=${woExId}&woUUID=${woId}`)

                const res = await axios.get(
                    `${getWorkOrderDetailsAPIURL}?userUUID=${authUser.headers.userUUID}&exeUUID=${woExId}&woUUID=${woId}`,
                    {
                        headers: {
                            ...authUser.headers,
                            Authorization: `Bearer ${authUser.headers.access_token}`,
                        },
                    }
                );

                if (res.data.responseMsg == "Success") {
                    const apiData = res.data.data || {};
                    const master = apiData.workOrderMaster || {};
                    const address = apiData.workOrderAddress || {};
                    const products = apiData.workOrderDetails || [];
                    const executions = apiData.workOrderExecutions || [];

                    // ✅ Work Order Info
                    const formattedWorkOrderData = workOrderInfo.map((item) => ({
                        ...item,
                        value: master[item.key] ?? "",
                    }));
                    setWorkOrderInfo(formattedWorkOrderData);

                    // ✅ Customer Details
                    const formattedCustomerDetailsData = customerDetails.map((item) => {
                        let value = "";
                        if (item.key in master) value = master[item.key];
                        else if (item.key in address) value = address[item.key];
                        return { ...item, value };
                    });
                    setCustomerDetails(formattedCustomerDetailsData);

                    // ✅ Product Details (loop through each product record)
                    const formattedProducts = products.map((prod) =>
                        productDetails.map((item) => ({
                            ...item,
                            value: prod[item.key] ?? "",
                        }))
                    );

                    // ✅ Set state as an array of product detail groups
                    setProductDetails(formattedProducts);
                    // console.log("✅ Product Details Added: ", JSON.stringify(formattedProducts));
                    
                    // ✅ executions Details (loop through each product record)
                    const formattedExecutions = executions.map((exe) =>
                        
                        executionDetails.map((item) => ({
                            ...item,
                            value: exe[item.key] ?? "",
                        }))
                    );
                    setExecutionDetails(formattedExecutions);

                } else {
                    console.error("Schedular API Response Error: ", res.data.responseMsg);
                }
            } catch (err) {
                console.error("Error fetching schedular list: ", err);
                openPopup("Requested Data Not Found / 404", "warn");
            }
        }
    };




    if (!canRead) {
        return (
            <Container fluid className="page-content">
                <Breadcrumbs title="Users" breadcrumbItem="Work Order Details" />
                <CantAccessPage />
            </Container>
        );
    }

    if (loaderOption) return <Loader />;

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs title="Users" breadcrumbItem="Work Order Details" />
                <Card>
                    <CardBody>

                        <div className="row">
                            <div className="col-sm-12">
                                {/* ✅ Back Button */}
                                <button
                                    type="button"
                                    className="btn btn-sm btn-warning"
                                    style={{ fontWeight: "500", fontSize: '12px', float: 'right' }}
                                    onClick={() => {
                                        navigate('/workOrderList', {
                                            state: {
                                                fromDate,
                                                toDate,
                                                triggerFetch: true   // ⭐ ADD THIS FLAG
                                            }
                                        });
                                    }}
                                >
                                    Back To WO List
                                </button>
                            </div>
                        </div>

                        {/* Header */}
                        <div className="d-flex align-items-center mb-3">
                            <h5
                                style={{
                                    color: "#005194",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Work Order Information
                            </h5>
                            <hr
                                style={{
                                    flex: 1,
                                    borderTop: "2px solid #005194",
                                    marginTop: "10px",
                                }}
                            />

                        </div>

                        {/* Work Order Info Grid */}
                        <div className="container">
                            <div className="row">
                                {workOrderInfo.map((item, index) => {
                                    if (item.fullWidth) {
                                        return (
                                            <div
                                                key={index}
                                                className="col-12 mb-2"
                                                style={{
                                                    // borderTop: "1px solid #ccc",
                                                    // borderBottom: "1px solid #ccc",
                                                    // padding: "6px 0",
                                                }}
                                            >
                                                <span style={{ fontSize: '15px', fontWeight: '550', color: '#71717B' }}>{item.label}</span>
                                                <span style={{ color: item.color || "inherit", fontSize: '14px' }}>
                                                    {item.value}
                                                </span>
                                            </div>
                                        );
                                    }

                                    return (
                                        <div className="col-md-4 mb-2" key={index}>
                                            <span style={{ fontSize: '15px', fontWeight: '550', color: '#71717B' }}>{item.label}</span>
                                            <span
                                                style={{
                                                    color: item.color || "inherit",
                                                    fontWeight: item.bold ? "bold" : "normal",
                                                    fontSize: '14px'
                                                }}
                                            >
                                                {item.value}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Customer Details */}
                        <div className="d-flex align-items-center mb-3 mt-3">
                            <h5
                                style={{
                                    color: "#005194",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Customer Details
                            </h5>
                            <hr
                                style={{
                                    flex: 1,
                                    borderTop: "2px solid #005194",
                                    marginTop: "10px",
                                }}
                            />
                        </div>

                        <div className="container">
                            <div className="row">
                                {customerDetails.map((item, index) => {
                                    const handleCopy = (text) => {
                                        navigator.clipboard.writeText(text);
                                        openPopup("Copied to clipboard!", "success");
                                    };

                                    if (item.half) {
                                        return (
                                            <div className="col-md-6 mb-2 d-flex align-items-start" key={index}>
                                                <div style={{ flex: 1 }}>
                                                    <span style={{ fontSize: '15px', fontWeight: '550', color: '#71717B' }}>{item.label}</span>
                                                    <span
                                                        style={{
                                                            fontWeight: item.bold ? "bold" : "normal",
                                                            fontSize: '14px',
                                                            wordBreak: 'break-word'
                                                        }}
                                                    >
                                                        {item.value}
                                                    </span>
                                                </div>

                                                {/* ✅ Show Copy button only for Address & Location */}
                                                {item.copy && (
                                                    <FaCopy
                                                        onClick={() => handleCopy(item.value)}
                                                        title="Copy to clipboard"
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "#0d6efd",
                                                            fontSize: "16px",
                                                            marginLeft: "4px",
                                                        }}
                                                    />
                                                )}

                                            </div>
                                        );
                                    }

                                    return (
                                        <div className="col-md-4 mb-2" key={index}>
                                            <span style={{ fontSize: '15px', fontWeight: '550', color: '#71717B' }}>{item.label}</span>
                                            <span
                                                style={{
                                                    fontWeight: item.bold ? "bold" : "normal",
                                                    fontSize: '14px'
                                                }}
                                            >
                                                {item.value}
                                            </span>
                                        </div>
                                    );
                                })}

                            </div>
                        </div>

                        {/* Product Details */}
                        <div className="d-flex align-items-center mb-3 mt-3">
                            <h5
                                style={{
                                    color: "#005194",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Product Details
                            </h5>
                            <hr
                                style={{
                                    flex: 1,
                                    borderTop: "2px solid #005194",
                                    marginTop: "10px",
                                }}
                            />
                        </div>

                        {/* Product Details Grid */}
                        <div className="container">
                            {Array.isArray(productDetails) &&
                                productDetails.map((product, productIndex) => (
                                    <div key={productIndex} className="row mb-4 border-bottom pb-3">
                                        <div className="col-12 mb-2">
                                            <h6
                                                style={{
                                                    fontWeight: "600",
                                                    color: "#FF692A", // A nice blue accent
                                                    fontSize: "16px",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                Product {productIndex + 1}
                                            </h6>
                                        </div>

                                        {Array.isArray(product) &&
                                            product.map((item, index) => (
                                                <div
                                                    className={item.fullWidth ? "col-12 mb-2" : "col-md-4 mb-2"}
                                                    key={index}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "550",
                                                            color: "#71717B",
                                                            marginRight: "4px",
                                                        }}
                                                    >
                                                        {item.label}
                                                    </span>
                                                    <span
                                                        style={{
                                                            color: item.color || "inherit",
                                                            fontWeight: item.bold ? "bold" : "normal",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {item.value}
                                                    </span>
                                                </div>
                                            ))}
                                    </div>
                                ))}
                        </div>


                        {/* Execution Details */}
                        <div className="d-flex align-items-center mb-3 mt-3">
                            <h5
                                style={{
                                    color: "#005194",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Execution Details
                            </h5>
                            <hr
                                style={{
                                    flex: 1,
                                    borderTop: "2px solid #005194",
                                    marginTop: "10px",
                                }}
                            />
                        </div>

                        {/* Execution Details Grid */}
                               {/* <div className="container">
                                {Array.isArray(executionDetails) &&

                                processedExecutions.map(({ execution, status }, executionIndex) => {
                                   // executionDetails.map((execution, executionIndex) => {
                                        
                                    //const status = getExecutionStatus(execution);
const processedExecutions = useMemo(() => {
  if (!Array.isArray(executionDetails)) return [];

  return executionDetails.map((execution) => ({
    execution,
    status: getExecutionStatus(execution),
  }));
}, [executionDetails]);
                                    return (
                                        <div
                                        key={executionIndex}
                                        className={`row mb-4 border-bottom pb-3 ${
                                            status === "delayed"
                                            ? "border border-danger rounded p-2"
                                            : ""
                                        }`}
                                        >
                                        <div className="col-12 mb-2">
                                            <h6
                                            style={{
                                                fontWeight: "600",
                                                color: "#FF692A",
                                                fontSize: "16px",
                                                marginBottom: "8px",
                                            }}
                                            >
                                            Execution {executionIndex + 1}
                                            </h6>
                                        </div>

                                        {Array.isArray(execution) &&
                                            execution.map((item, index) => (
                                            <div
                                                className={item.fullWidth ? "col-12 mb-2" : "col-md-4 mb-2"}
                                                key={index}
                                            >
                                                <span
                                                style={{
                                                    fontSize: "15px",
                                                    fontWeight: "550",
                                                    color: "#71717B",
                                                    marginRight: "4px",
                                                }}
                                                >
                                                {item.label}
                                                </span>

                                                {item.key === "executionStatus" ? (                                              

                                                    <span
                                                        className={`badge ${getBadgeClass(status)}`}
                                                        style={{
                                                            fontSize: "13px",
                                                            padding: "6px 10px",
                                                            borderRadius: "20px",
                                                            fontWeight: "600",
                                                            letterSpacing: "0.3px",
                                                        }}
                                                        >
                                                        {getStatusLabel(status)}

                                                        {status === "delayed" && (
                                                            <i className="mdi mdi-alert-circle text-danger ms-1"></i>
                                                        )}
                                                    </span>
                                                ) : (
                                                <span>{item.value}</span>
                                                )}
                                            </div>
                                            ))}
                                        </div>
                                    );
                                    })}
                                </div> */}

                                <div className="container">
                                    
                                    {processedExecutions.map(({ execution, status }, executionIndex) => { 
                                        let isCompleted, isCancelled;

                                        if (Array.isArray(execution)) {
                                        // when execution is array
                                        isCompleted = execution.find(i => i.key === "isExecutionCompleted")?.value;
                                        isCancelled = execution.find(i => i.key === "isExecutionCancelled")?.value;
                                        } else {
                                        // when execution is object
                                        isCompleted = execution?.isExecutionCompleted;
                                        isCancelled = execution?.isExecutionCancelled;
                                        }

                                        const canPostpone =
                                        isCompleted === "Pending" &&
                                        isCancelled === "No";
                                        //    console.log('execution.isExecutionCompleted - ' + execution.isExecutionCompleted);

                                        return (

                                        <div
                                            key={executionIndex}
                                            className={`row mb-4 border-bottom pb-3 ${
                                            status === "delayed"
                                                ? "border border-danger rounded p-2"
                                                : ""
                                            }`}
                                        >
                                            <div className="col-12 mb-2">
                                            <h6 style={{ fontWeight: "600", color: "#FF692A" }}>
                                                Execution {executionIndex + 1}
                                            </h6>
                                            </div>

                                            {Array.isArray(execution) &&
                                            execution.map((item, index) => (
                                                <div
                                                className={item.fullWidth ? "col-12 mb-2" : "col-md-4 mb-2"}
                                                key={index}
                                                >
                                                <span>{item.label}</span>

                                                 {/* // {item.key === "executionStatus" ? ( 

                                                     // <span className={`badge ${getBadgeClass(status)}`}
                                                    //                 style={{
                                                    //     fontSize: "13px",
                                                    //     padding: "6px 10px",
                                                    //     borderRadius: "20px",
                                                    //     fontWeight: "600",
                                                    //     letterSpacing: "0.3px",
                                                    // }}
                                                    // >
                                                    // {getStatusLabel(status)}
                                                    // </span>  */}

                                                    {item.key === "isExecutionCompleted" ? (
                                                            <span
                                                                className={`badge ${
                                                                item.value === "Yes" ? "bg-success" : "bg-warning"
                                                                }`}
                                                                style={{ fontSize: "12px", padding: "6px 10px" }}
                                                            >
                                                                {item.value === "Yes" ? "Completed" : item.value}
                                                            </span>

                                                    
                                                ) : (
                                                     <span>{item.key === "isExecutionCancelled" ? (
                                                            <span
                                                                className={`badge ${
                                                                item.value === "Yes" ? "bg-danger" : "bg-success"
                                                                }`}
                                                                style={{ fontSize: "12px", padding: "6px 10px" }}
                                                            >
                                                                {item.value === "Yes" ? "Cancelled" : "Active"}
                                                            </span>
                                                            ) : (
                                                            <span>{item.value}</span>
                                                            )}</span>                                                     
                                                )}

                                                </div>
                                            ))}

                                          {canPostpone && (
                                            <div className="col-12 mt-3">

                                                {/* 🔹 ROW 1 → Inputs */}
                                                <div className="row">

                                                {/* 📅 Date */}
                                                <div className="col-md-4 col-sm-6 mb-2">
                                                    <label className="form-label">Postpone Date</label>
                                                    <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={postponeDate || ""}
                                                    onChange={(e) => setPostponeDate(e.target.value)}
                                                    />
                                                </div>

                                                {/* 📋 Reason */}
                                                <div className="col-md-4 col-sm-6 mb-2">
                                                    <label className="form-label">Reason</label>
                                                    <select
                                                    className="form-control form-control-sm"
                                                    value={reason || ""}
                                                    onChange={(e) => setReason(e.target.value)}
                                                    >
                                                    <option value="">Select Reason</option>
                                                    <option value="Customer Request">Customer Request</option>
                                                    <option value="Staff Not Available">Staff Not Available</option>
                                                    </select>
                                                </div>

                                                {/* 📝 Remark */}
                                                <div className="col-md-4 col-sm-12 mb-2">
                                                    <label className="form-label">Remark</label>
                                                    <input
                                                    type="text"
                                                    maxLength={40}
                                                    className="form-control form-control-sm"
                                                    value={remark || ""}
                                                    onChange={(e) => setRemark(e.target.value)}
                                                    />
                                                    <small className="text-muted">
                                                    {remark?.length || 0}/40
                                                    </small>
                                                </div>

                                                </div>

                                                {/* 🔹 ROW 2 → Button */}
                                                <div className="row mt-2">
                                                <div className="col-12 text-end">
                                                    <button
                                                    className="btn btn-warning btn-sm px-4"
                                                    onClick={() => handleReschedule(execution)}
                                                    >
                                                    Reschedule
                                                    </button>
                                                </div>
                                                </div>

                                            </div>
                                            )}      






                                            
                                        </div>
                                        );
                                    })}
                              
                                    

                                </div>
                    </CardBody>
                </Card>
            </Container>

            {
                isPopupVisible && (
                    <PopupWindow
                        message={popupMessage}
                        type={popupType}
                        onClose={closePopup}
                    />
                )
            }
        </div >
    );
};

WorkOrderDetails.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(WorkOrderDetails);
